import styled from 'styled-components';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background: linear-gradient(135deg, #fff 0%, #eee 100%), #dfdfdf;
  min-width: 980px;
  min-height: 551.25px;
`;

export const Slide1 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    h2 {
      position: absolute;
      left: 83.46px;
      top: 114.21px;
      width: 584.15px;
      color: #543d3d;
      font-size: 40px;
      font-weight: 500;
      line-height: 40.24px;
    }

    h3 {
      position: absolute;
      left: 83.46px;
      top: 215.79px;
      width: 513.26px;
      color: #543d3d;
      font-size: 30px;
      font-weight: 300;
      line-height: 36.18px;
    }

    .tag {
      position: absolute;
      width: max-content;
      border-radius: 87px;
      background: rgba(190, 126, 56, 0.4);
      color: #000;
      font-size: 30px;
      font-weight: 300;
      line-height: 42.27px;
      padding: 13.62px 25.57px;
    }

    .tag-1,
    .tag-2,
    .tag-3 {
      top: 341.83px;
    }

    .tag-4,
    .tag-5 {
      top: 423.28px;
    }

    .tag-1,
    .tag-4 {
      left: 83.46px;
    }

    .tag-2 {
      left: 249px;
    }

    .tag-3 {
      left: 425px;
    }

    .tag-5 {
      left: 281px;
    }

    .man,
    .woman-1,
    .woman-2 {
      width: 170.7px;
      height: 184px;
      position: absolute;
      left: 809px;
    }

    .man {
      top: 0px;
    }

    .woman-1 {
      top: 183px;
    }

    .woman-2 {
      top: 366px;
    }
  }
`;

export const Slide2 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .title {
      position: absolute;
      left: 262.25px;
      top: 62.17px;
      width: 455.25px;
      color: #543d3d;
      font-size: 30px;
      font-weight: 500;
      line-height: 30.18px;
      text-align: center;
    }

    .man {
      position: absolute;
      left: 0;
      top: 176.22px;
      width: 487px;
      height: 375px;
    }

    .woman {
      position: absolute;
      left: 487px;
      top: 176.22px;
      width: 493px;
      height: 375px;
    }

    .clear-correct {
      position: absolute;
      left: 420.29px;
      top: 490px;
      width: 139.42px;
      height: 33.15px;
    }
  }
`;

export const Slide3 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .title {
      position: absolute;
      left: 65.38px;
      top: 74.69px;
      width: 216px;
      color: #b1691b;
      font-size: 30px;
      font-weight: 500;
      letter-spacing: -1.5px;
    }

    .content {
      position: absolute;
      left: 65.38px;
      top: 134.69px;
      width: 410.8px;
      color: #9d7a5c;
      font-size: 30px;
      font-weight: 500;
      line-height: 33px;
      letter-spacing: -1.5px;

      span {
        color: #6d3809;
      }
    }

    .woman {
      position: absolute;
      left: 584.42px;
      top: 74.95px;
      width: 314.7px;
      height: 412.67px;
    }

    .aligner {
      position: absolute;
      left: 0px;
      top: 390.22px;
      width: 261px;
      height: 161px;
    }
  }
`;

export const Slide4 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .notice {
      position: absolute;
      left: 74.91px;
      top: 74.69px;
      width: 824.02px;
      height: 232.9px;
    }

    .source {
      position: absolute;
      left: 74.91px;
      top: 315.04px;
      width: 140px;
      color: #995c19;
      font-size: 20px;
      font-style: italic;
      line-height: 22px;
      letter-spacing: -1px;
    }

    .content {
      position: absolute;
      left: 74.91px;
      top: 379.15px;
      width: 740.79px;
      color: #543d3d;
      font-size: 24px;
      font-weight: 300;
      line-height: 28.94px;
    }
  }
`;
